export default "__VITE_ASSET__4d977a8f__"